import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import {
  getBusinessRelatonsInitialValuesSoleTrader,
  getBusinessRelatonsInitialValuesLegalResident,
  getBusinessRelatonsInitialValuesReIdentificationSoleTrader,
} from '../utils';
import { TPurposeOfBusinessRelations } from '../types';
import {
  legalResidentValidationSchema,
  reIdentificationSoleTraderValidationSchema,
  soleTraderValidationSchema,
} from '../validationSchema';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';
import * as yup from 'yup';
import { cloneDeep } from 'lodash';
import {
  selectIsReidentification,
  selectPurposeOfBusinessRelations,
} from '~/store/identification-form/selectors';

export const useBusinessRelationsForm = () => {
  const { isSoleTrader } = useGetContragentTypes();
  const purposeOfBusinessRelations = useSelector(selectPurposeOfBusinessRelations);
  const isReidentification = useSelector(selectIsReidentification);

  const initialValues = isSoleTrader
    ? isReidentification
      ? getBusinessRelatonsInitialValuesReIdentificationSoleTrader(
          purposeOfBusinessRelations as TPurposeOfBusinessRelations
        )
      : getBusinessRelatonsInitialValuesSoleTrader(
          purposeOfBusinessRelations as TPurposeOfBusinessRelations
        )
    : getBusinessRelatonsInitialValuesLegalResident(
        purposeOfBusinessRelations as TPurposeOfBusinessRelations
      );

  const schema = yup.lazy(() => {
    return isSoleTrader
      ? isReidentification
        ? reIdentificationSoleTraderValidationSchema
        : soleTraderValidationSchema
      : legalResidentValidationSchema;
  }) as unknown as yup.ObjectSchema<TPurposeOfBusinessRelations>;

  const form = useForm<TPurposeOfBusinessRelations>({
    resolver: yupResolver(schema) as Resolver<TPurposeOfBusinessRelations>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
